(() => {
  if (window.SKNHeroVideo) {
    window.SKNHeroVideo.init(document);
    return;
  }
  const instances = new WeakMap();

  function initialize(root) {
    if (instances.has(root)) return;
    const video = root.querySelector('video');
    const fallback = root.querySelector('.skn-hero-video-fallback');
    const errorStatus = root.querySelector('[data-hero-video-error]');
    if (!video || !fallback) return;

    const events = new AbortController();
    const options = {signal: events.signal};
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const failedSources = new Set();
    const sources = [...video.querySelectorAll('source')];
    let inView = false;
    let autoplayRejected = false;
    let failed = false;
    let destroyed = false;

    function showFallback() {
      if (destroyed || failed) return;
      failed = true;
      video.pause();
      video.hidden = true;
      fallback.hidden = false;
      if (errorStatus) errorStatus.hidden = false;
    }

    function requestPlay() {
      if (destroyed || failed) return;
      const playback = video.play();
      if (!playback || typeof playback.catch !== 'function') return;
      playback.catch(error => {
        if (destroyed || error.name === 'AbortError') return;
        if (video.error) showFallback();
        else autoplayRejected = true;
      });
    }

    function updateVisibility() {
      if (!inView || document.hidden || reduced.matches) {
        video.pause();
        return;
      }
      if (!autoplayRejected && video.paused) requestPlay();
    }

    video.addEventListener('error', showFallback, options);
    sources.forEach(source => source.addEventListener('error', () => {
      failedSources.add(source);
      if (failedSources.size === sources.length && video.readyState === 0) showFallback();
    }, options));
    document.addEventListener('visibilitychange', updateVisibility, options);
    reduced.addEventListener('change', updateVisibility, options);

    const observer = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
      updateVisibility();
    }, {threshold: [0, .25]});
    video.autoplay = false;
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    video.controls = false;
    observer.observe(root);
    if (video.error || video.networkState === HTMLMediaElement.NETWORK_NO_SOURCE) showFallback();

    instances.set(root, () => {
      destroyed = true;
      observer.disconnect();
      events.abort();
      video.pause();
      video.controls = true;
      instances.delete(root);
    });
  }

  function rootsWithin(scope) {
    const roots = [...scope.querySelectorAll('[data-hero-video]')];
    if (scope.matches && scope.matches('[data-hero-video]')) roots.unshift(scope);
    return roots;
  }

  function init(scope) { rootsWithin(scope).forEach(initialize); }
  window.SKNHeroVideo = {init};
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    rootsWithin(event.target).forEach(root => instances.get(root)?.());
  });
})();
